import React from 'react';
import { Link } from 'react-router-dom';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'outline' | 'solid';
  className?: string;
  href?: string;
}
export function Button({
  children,
  variant = 'outline',
  className = '',
  href
}: ButtonProps) {
  const base = 'inline-block px-[32px] py-[18px] font-bold text-[14px] tracking-[0.06em] uppercase border-2 transition-all duration-200 ease-out';
  const variants = {
    outline: 'border-brand-black text-brand-black hover:bg-brand-black hover:text-brand-white',
    solid: 'border-brand-black bg-brand-black text-brand-white hover:bg-brand-white hover:text-brand-black'
  };
  const classes = `${base} ${variants[variant]} ${className}`;
  if (href) {
    if (href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('#')) {
      return <a href={href} className={classes} data-id="element-21" data-mp="30rrxx074j41a">
          {children}
        </a>;
    }
    return <Link to={href} className={classes} data-id="element-22" data-mp="2vxnn25uqmbux">
        {children}
      </Link>;
  }
  return <button className={classes} data-id="element-23" data-mp="d28ppju7ge59">{children}</button>;
}